module.exports = __webpack_public_path__ + "media/images/media_video-5e579144eeef895e6413fc4a2ef7864e.png";